import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Programs3DCube from '../components/Programs3DCube';

// Standalone preview at /preview/programs-cube. Shown to the user for sign-off
// BEFORE the 3D cube is embedded into the LandingPage cover.
const Preview3DCubePage = () => (
  <div style={{ background: '#050913', minHeight: '100vh' }}>
    <div
      style={{
        position: 'fixed',
        top: 16,
        left: 16,
        zIndex: 50,
        display: 'flex',
        gap: 10,
        alignItems: 'center',
      }}
    >
      <Link
        to="/"
        data-testid="preview-back-home"
        style={{
          background: 'rgba(11,19,45,0.85)',
          color: '#f7d774',
          border: '1px solid rgba(247,215,116,0.35)',
          padding: '8px 12px',
          borderRadius: 8,
          textDecoration: 'none',
          fontWeight: 700,
          fontSize: '0.85rem',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          backdropFilter: 'blur(8px)',
        }}
      >
        <ArrowLeft size={14} /> Back to MedCare
      </Link>
      <div
        data-testid="preview-banner"
        style={{
          background: 'rgba(247,215,116,0.92)',
          color: '#0b132d',
          padding: '8px 12px',
          borderRadius: 8,
          fontWeight: 800,
          fontSize: '0.78rem',
          letterSpacing: 0.5,
        }}
      >
        PREVIEW MODE · Not yet live on the cover
      </div>
    </div>
    <Programs3DCube />
  </div>
);

export default Preview3DCubePage;
